import { styled, Tabs } from "@mui/material";

type SwitcherProps<Value extends string> = {
  value: Value;
  onChange: (value: Value) => void;
  children?: React.ReactNode;
};

export function Switcher<Value extends string>({
  value,
  onChange,
  children,
}: SwitcherProps<Value>) {
  return (
    <SwitcherContainer
      variant="fullWidth"
      centered
      value={value}
      onChange={(event, newValue: Value) => {
        onChange(newValue);
      }}
    >
      {children}
    </SwitcherContainer>
  );
}

const SwitcherContainer = styled(Tabs)(() => ({
  backgroundColor: "var(--color-surface-neutral-medium)",
  borderRadius: "var(--radius-xl)",
  padding: "calc(var(--spacing)*2)",
  minHeight: "unset",
  width: "100%",

  "& .MuiTabs-indicator": {
    height: "100%",
    zIndex: 0,
    backgroundColor: "var(--color-white)",
    borderRadius: "var(--radius-lg)",
  },

  "& .MuiTabs-list": {
    position: "relative",
    backgroundColor: "transparent",
    zIndex: 1,
  },
}));
